module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    },
    slot: "left"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content frm-login"
  }, [_c('mt-swipe', {
    attrs: {
      "auto": 4000,
      "show-indicators": true,
      "speed": 300
    }
  }, [_c('mt-swipe-item', [_vm._v(_vm._s(_vm.$t('info.message_login_1')))]), _vm._v(" "), _c('mt-swipe-item', [_vm._v(_vm._s(_vm.$t('info.message_login_2')))]), _vm._v(" "), _c('mt-swipe-item', [_vm._v(_vm._s(_vm.$t('info.message_login_3')))]), _vm._v(" "), _c('mt-swipe-item', [_vm._v(_vm._s(_vm.$t('info.message_login_4')))])], 1), _vm._v(" "), _c('mt-button', {
    staticClass: "facebook btn-social",
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.doLogin(_vm.credentials, 'facebook')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("buttons.signin_with")) + " "), _c('b', [_vm._v(_vm._s(_vm.$t("buttons.facebook")))])]), _vm._v(" "), _c('mt-button', {
    staticClass: "google btn-social",
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.doLogin(_vm.credentials, 'google')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-google",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("buttons.signin_with")) + " "), _c('b', [_vm._v(_vm._s(_vm.$t("buttons.google")))])]), _vm._v(" "), _c('router-link', {
    staticClass: "link-email",
    attrs: {
      "to": {
        name: 'signin'
      }
    }
  }, [_c('mt-button', {
    staticClass: "email btn-social",
    attrs: {
      "size": "large",
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("buttons.signin_with")) + " "), _c('b', [_vm._v(_vm._s(_vm.$t("buttons.email")))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "forgot-password"
  }, [_c('router-link', {
    staticClass: "forgot",
    attrs: {
      "to": {
        name: 'forgot',
        params: {
          email: _vm.credentials.email
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("links.forgot_pass")) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-legend"
  }, [_vm._v(_vm._s(_vm.$t("info.are_you_new")) + "\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("info.register")))])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('img', {
    attrs: {
      "id": "logo",
      "src": require("../../../assets/images/logo.png"),
      "onerror": "this.onerror=null; this.src='logo.png'"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6eeff57c!./src/app/pages/login/index.html
// module id = 755
// module chunks = 18